module.exports = __webpack_public_path__ + "img/oculus_hifi_6.eafd8a62.png";